import { Component, computed, ElementRef, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheckSquare, faMagnifyingGlass, faSquare } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { MspPipesModule } from 'src/app/util/pipes/msp-pipes.module';
import { FormsModule } from '@angular/forms';

interface search {
	values: any[];
	filter: string;
}

@Component({
	selector: 'msp-table-sort-dropdown',
	standalone: true,
	imports: [CommonModule, FaIconComponent, MspPipesModule, FormsModule],
	templateUrl: './msp-table-sort-dropdown.component.html',
	styleUrl: './msp-table-sort-dropdown.component.scss',
})
export class MspTableSortDropdownComponent implements OnInit, OnChanges {
	private readonly labelsService = inject(LabelsService);
	element: ElementRef['nativeElement'];
	icons = {
		faMagnifyingGlass: faMagnifyingGlass,
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
	};

	labels: LabelsInterface = {};

	@Input() headerData: mspTableHeaderI;

	search: search = {
		values: [],
		filter: '',
	};
	dirtySearch = false;
	@Output() getSearch = new EventEmitter<{ id: string; values: any[] }>();
	openDropdown = false;

	allSelected = () => {
		return this.headerData.items?.every((item) => item.disabled || item.selected) ?? false;
	};

	constructor(element: ElementRef) {
		this.element = element.nativeElement;
		this.filterSearchOptions = this.filterSearchOptions.bind(this);
		this.labels = computed(() => this.labelsService.labels())();
	}

	ngOnInit(): void {
		if (!this.headerData) {
			throw new Error('Header data is required for MspTableSortDropdownComponent');
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['headerData']) {
			if (changes['headerData'].firstChange && (this.headerData.colType == 'text' || this.headerData.colType == 'date')) {
				this.search.values[0] = '';
			}
			if (this.headerData.colType === 'text' && this.headerData.startSearch?.length > 0) {
				this.search.values[0] = this.headerData.startSearch.join(', ');
			}
		}
	}

	handleClickOutside = (event: MouseEvent) => {
		if (!this.element.contains(event.target)) {
			this.openDropdown = false;
			this.doSearch();
			document.removeEventListener('click', this.handleClickOutside);
		}
	};

	toggleDropdown(event?: MouseEvent) {
		this.openDropdown = !this.openDropdown;
		if (this.openDropdown) {
			setTimeout(() => {
				document.addEventListener('click', this.handleClickOutside);
			});
		} else {
			this.doSearch();
			document.removeEventListener('click', this.handleClickOutside);
		}
	}

	doSearch() {
		if (!this.dirtySearch) return;
		this.syncSearchValues();
		this.getSearch.emit({ id: this.headerData.name, values: this.search.values });
		this.dirtySearch = false;
	}

	syncSearchValues() {
		if (this.headerData.colType !== 'text' && this.headerData.colType !== 'date') {
			this.search.values = [];
			if (this.headerData.items)
				for (const item of this.headerData.items) this.search.values.push(...(item.selected ? item.values : []));
			return;
		}
	}

	filterSearchOptions(loopItem: any): boolean {
		const allEmpty = this.search.filter.trim() === '';
		if (allEmpty) return true;

		let searchParameter = this.search.filter;
		if (!loopItem || searchParameter == undefined || searchParameter == '') return false;

		let valueLabel = loopItem.label;
		const noWhiteSpaceValueLabel = valueLabel.replaceAll(/\s+/g, '');
		searchParameter = searchParameter.trim();
		if (this.labels[loopItem.label] != undefined) valueLabel = this.labels[loopItem.label];

		return (
			valueLabel.toLowerCase().includes(searchParameter.toLowerCase()) ||
			noWhiteSpaceValueLabel.toLowerCase().includes(searchParameter.toLowerCase())
		);
	}

	toggleSelectAll() {
		if (this.allSelected()) {
			for (const item of this.headerData.items) !item.disabled && (item.selected = false);
			this.search.values = [];
		} else {
			for (const item of this.headerData.items) !item.disabled && (item.selected = true);
			this.search.values = this.headerData.items.filter((item) => !item.disabled).map((item) => item.values[0]);
		}
	}

	toggleSelectItem(item: mspTableHeaderI['items'][number]) {
		item.selected = !item.selected;
		this.toggleSearchValues(item);
	}

	toggleSearchValues(item: mspTableHeaderI['items'][number]): void {
		const value = item.values[0];
		this.search.values.find((value_) => value_ === value)
			? (this.search.values = this.search.values.filter((value_) => value_ !== value))
			: this.search.values.push(value);
	}

	//Essa função é necessária para facilitar o toggle em acesso externo
	deselectAll() {
		if (this.headerData.colType == 'text' || this.headerData.colType == 'date') {
			this.search.values[0] = '';
		} else {
			if (this.headerData.items) for (const item of this.headerData.items) !item.disabled && (item.selected = false);
			this.search.values = [];
		}
	}
}
